<main
    class="account-blocked"
    *transloco="let t; read: 'platform_alerts.billing.blocked'"
>
    <div class="account-blocked__vector"></div>

    <div class="account-blocked__content">
        <img
            class="account-blocked__logo"
            src="/assets/images/Logo-original.svg"
            alt="Atom"
        />

        <section class="account-blocked__card" role="alert">
            <header class="account-blocked__header">
                <span class="account-blocked__lock">
                    <mat-icon>lock</mat-icon>
                </span>
                <h1 class="account-blocked__title">{{ t("title") }}</h1>
                <p class="account-blocked__reason">{{ t("reason") }}</p>
            </header>

            <div class="account-blocked__body">
                <div class="account-blocked__notice">
                    <mat-icon
                        class="account-blocked__notice-icon"
                        fontSet="material-icons-outlined"
                        >info</mat-icon
                    >
                    <p class="account-blocked__contact">{{ t("contact") }}</p>
                </div>
            </div>
        </section>
    </div>
</main>
